import { SvgIcon, SvgIconProps } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';

//Created a custom SVG Icon extending MUI with Agent generated code
const CopyIdIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      {/* Base copy icon paths */}
      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
      {/* ID text overlay */}
      <text
        x="14"
        y="17"
        textAnchor="middle"
        fontSize="8"
        fontWeight="bold"
        fill="currentColor"
        fontFamily="Arial, sans-serif"
      >
        ID
      </text>
    </SvgIcon>
  );
};

// Add muiName property to match IconElementType interface
(CopyIdIcon as OverridableComponent<SvgIconTypeMap<object, 'svg'>> & { muiName: string }).muiName =
  'CopyIdIcon';

export default CopyIdIcon as OverridableComponent<SvgIconTypeMap<object, 'svg'>> & {
  muiName: string;
};
